(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6450],{

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(43100)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 69641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ blog_BlogComponent; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 13 modules
var Page = __webpack_require__(9092);
// EXTERNAL MODULE: ./components/shared/Badge.js
var Badge = __webpack_require__(55952);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./components/marketingSite/talentEngineV3/sections/nav/Nav.tsx + 3 modules
var Nav = __webpack_require__(463);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var client_router = __webpack_require__(93642);
// EXTERNAL MODULE: ./utils/logos.ts
var logos = __webpack_require__(4335);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/blog/BlogCard.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 13.75rem;\n  text-align: left;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  color: inherit;\n\n  cursor: pointer;\n  transition: 0.3s;\n\n  @media (min-width: ",
        ") {\n    display: flex;\n  }\n\n  &:hover {\n    box-shadow: ",
        ";\n    color: inherit;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: ",
        " ",
        " 0 0;\n  overflow: hidden;\n  height: 14rem;\n\n  @media (min-width: ",
        ") {\n    width: 12.5rem;\n    height: auto;\n    border-radius: ",
        " 0 0 ",
        ";\n  }\n\n  img {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: ",
        ";\n  height: 100%;\n  width: 100%;\n  background-image: linear-gradient(\n    47deg,\n    ",
        ",\n    ",
        " 70%\n  );\n\n  img {\n    height: auto;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  text-transform: uppercase;\n  margin: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n  margin-top: 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n\n  p:first-child {\n    margin-top: 0;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var StyledCard = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-4d6e500a-0"
})(_templateObject(), (0,theme/* color */.$_)("white"), (0,theme/* radius */.q0)("md"), (0,theme/* shadow */.AF)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* shadow */.AF)("card"));
var StyledThumb = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4d6e500a-1"
})(_templateObject1(), (0,theme/* radius */.q0)("md"), (0,theme/* radius */.q0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* radius */.q0)("md"), (0,theme/* radius */.q0)("md"));
var StyledEmptyThumb = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4d6e500a-2"
})(_templateObject2(), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("purple_700"), (0,theme/* color */.$_)("mint_900"));
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4d6e500a-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("lg"));
var StyledDate = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4d6e500a-4"
})(_templateObject4(), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontSize */.JB)("sm"));
var StyledTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-4d6e500a-5"
})(_templateObject5(), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* spacing */.W0)("md"));
var StyledExcerpt = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4d6e500a-6"
})(_templateObject6(), (0,theme/* color */.$_)("text_subtle"));

;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/blog/BlogCard.tsx






var BlogCard = function(param) {
    var url = param.url, title = param.title, thumb = param.thumb, date = param.date, excerpt = param.excerpt;
    var locale = (0,client_router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineBlog */.uu.talentEngineBlog, locale), "/").concat(url),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledThumb, {
                    children: [
                        thumb && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: thumb,
                            alt: ""
                        }),
                        !thumb && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEmptyThumb, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: logos/* LOGO_MANFRED_WHITE */.YM,
                                alt: ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDate, {
                            children: new Date(date).toLocaleDateString(locale, {
                                year: "numeric",
                                month: "long",
                                day: "numeric"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledExcerpt, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: excerpt
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var blog_BlogCard = (BlogCard);

// EXTERNAL MODULE: ./components/marketingSite/shared/Cta.styled.tsx
var Cta_styled = __webpack_require__(7425);
;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/blog/BlogComponent.styled.ts

function BlogComponent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  max-width: ",
        ";\n  margin: auto;\n  text-align: center;\n\n  ",
        " {\n    margin-top: ",
        ";\n  }\n"
    ]);
    BlogComponent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BlogComponent_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    BlogComponent_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BlogComponent_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    BlogComponent_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BlogComponent_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  max-width: ",
        ";\n  margin: auto;\n"
    ]);
    BlogComponent_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var StyledBlog = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ae18920-0"
})(BlogComponent_styled_templateObject(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* container */.nC)("xl"), Cta_styled/* StyledCta */.B, (0,theme/* spacing */.W0)("xl5"));
var StyledBlogHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-2ae18920-1"
})(BlogComponent_styled_templateObject1(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl3"), Typography/* Heading1 */.nL, (0,theme/* spacing */.W0)("lg"));
var StyledTags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ae18920-2"
})(BlogComponent_styled_templateObject2(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xl3"));
var StyledBlogCards = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ae18920-3"
})(BlogComponent_styled_templateObject3(), (0,theme/* spacing */.W0)("lg"), (0,theme/* container */.nC)("md"));

// EXTERNAL MODULE: ./components/marketingSite/talentEngineV3/blog/BlogCta.tsx
var BlogCta = __webpack_require__(82467);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/blog/BlogPagination.styled.tsx

function BlogPagination_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n\n  .number {\n    @media (max-width: ",
        ") {\n      display: none;\n    }\n  }\n"
    ]);
    BlogPagination_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BlogPagination_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    BlogPagination_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledPagination = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4ae02498-0"
})(BlogPagination_styled_templateObject(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("mdMax"));
var StyledEllipsis = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4ae02498-1"
})(BlogPagination_styled_templateObject1(), (0,theme/* screen */.sp)("mdMax"));

;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/blog/BlogPagination.tsx










var ellipsis = /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEllipsis, {
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: pro_light_svg_icons/* faEllipsis */.S6C
    })
});
var BlogPagination = function(param) {
    var totalPages = param.totalPages, currentPage = param.currentPage, category = param.category;
    var locale = (0,client_router.useRouter)().locale;
    var pages = totalPages || 0;
    var page = currentPage || 1;
    var pagerPrefix = category ? "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineBlog */.uu.talentEngineBlog, locale), "/category/").concat(category, "/page/") : "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineBlog */.uu.talentEngineBlog, locale), "/page/");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPagination, {
        children: [
            pages > 1 && page > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(pagerPrefix, "1"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_styled/* default */.C, {
                            sizes: "sm",
                            variant: "secondary",
                            isIcon: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faArrowToLeft */.s87
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(pagerPrefix).concat(page - 1),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_styled/* default */.C, {
                            sizes: "sm",
                            variant: "secondary",
                            isIcon: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faArrowLeft */.acZ
                            })
                        })
                    })
                ]
            }),
            page - 2 > 0 && ellipsis,
            (0,_to_consumable_array/* default */.Z)(Array(pages)).map(function(p, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: i + 1 >= page - 1 && i + 1 <= page + 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(pagerPrefix).concat(i + 1),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_styled/* default */.C, {
                            sizes: "sm",
                            variant: page === i + 1 ? "active" : "secondary",
                            isIcon: true,
                            className: "number",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: i + 1
                            })
                        })
                    })
                }, "".concat(pagerPrefix).concat(i + 1));
            }),
            page + 2 <= pages && ellipsis,
            pages > 1 && page < pages && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(pagerPrefix).concat(page + 1),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_styled/* default */.C, {
                            sizes: "sm",
                            variant: "secondary",
                            isIcon: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faArrowRight */.eFW
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(pagerPrefix).concat(pages),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_styled/* default */.C, {
                            sizes: "sm",
                            variant: "secondary",
                            isIcon: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faArrowToRight */._Iw
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var blog_BlogPagination = (BlogPagination);

;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/blog/BlogComponent.tsx














function getPostThumb(post) {
    var ref;
    var embedded = (ref = post._embedded) === null || ref === void 0 ? void 0 : ref["wp:featuredmedia"];
    var media = embedded && embedded[0] ? embedded[0] : undefined;
    return media ? media.source_url : undefined;
}
var BlogComponent = function(param) {
    var posts = param.posts, category = param.category, totalPosts = param.totalPosts, totalPages = param.totalPages, currentPage = param.currentPage, tags = param.tags;
    var t = (0,useI18n/* useI18n */.Q)("talent-engine-blog").t;
    var ref = (0,router.useRouter)(), asPath = ref.asPath, locale = ref.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        hasScrollTop: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBlog, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBlogHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                                editorial: true,
                                children: t("talent-engine-blog.blog.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                ns: "talent-engine-blog",
                                i18nKey: "talent-engine-blog.blog.desc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTags, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineBlog */.uu.talentEngineBlog, locale),
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                    as: "a",
                                    variant: asPath === "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineBlog */.uu.talentEngineBlog, locale)) ? "primary" : "secondary",
                                    children: t("talent-engine-blog.blog.all")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineBlogWhatsNew */.uu.talentEngineBlogWhatsNew, locale),
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                    as: "a",
                                    variant: asPath === "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineBlogWhatsNew */.uu.talentEngineBlogWhatsNew, locale)) ? "primary" : "secondary",
                                    children: t("talent-engine-blog.blog.whatsnew")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBlogCards, {
                        children: Array.isArray(posts) && (posts === null || posts === void 0 ? void 0 : posts.length) > 0 ? posts.map(function(item) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(blog_BlogCard, {
                                title: item.title.rendered,
                                url: item.slug,
                                thumb: getPostThumb(item),
                                excerpt: ((ref = item.excerpt) === null || ref === void 0 ? void 0 : ref.rendered) || "",
                                date: item.date
                            }, item.slug);
                        }) : null
                    }),
                    totalPages > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_BlogPagination, {
                        totalPosts: totalPosts,
                        totalPages: totalPages,
                        currentPage: currentPage,
                        category: category
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCta/* default */.Z, {
                        tags: tags
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var blog_BlogComponent = (BlogComponent);


/***/ }),

/***/ 55952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* reexport safe */ _Badge_styled__WEBPACK_IMPORTED_MODULE_0__.C; }
/* harmony export */ });
/* harmony import */ var _Badge_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71487);



/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 63201:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ })

}]);